import BtnPrimaryM from "../Components/Buttons/BtnPrimaryM";
import Headline from "../Components/Elements/Headline";
import Subheadline from "../Components/Elements/Subheadline";
import { useLanguage } from "../context/LanguageContext";

const EmailChangeExpired = () => {
  const { copy } = useLanguage();

  return (
    <div className="w-full min-h-screen flex flex-col justify-center items-center background-page-color gap-8 h-screen">
      <a
        href="https://www.niumi.dk/"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-all duration-300 font-accent color-primary text-5xl"
      >
        NIUMI
      </a>
      <div className="flex flex-col gap-6 items-center">
        <Headline
          headline={copy.email_change.expired.headline}
          description={copy.email_change.expired.description}
          center
        />
      </div>

      <div className="card-base p-6 sm:p-8 card-base-border bg-white w-full max-w-[90vw] sm:w-[35vw] gap-4 sm:gap-6 flex flex-col">
        <Subheadline
          subheadline={copy.email_change.expired.subheadline}
          description={copy.email_change.expired.description_request}
        />
        <div className="flex self-center">
          <BtnPrimaryM
            buttonCTA={copy.email_change.expired.button_profile}
            onClickLink="/settings"
          />
        </div>
      </div>
    </div>
  );
};

export default EmailChangeExpired;
